module.exports = __webpack_public_path__ + "img/sepid5.66466e92.webp";